/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCards200ResponseInnerAvailableMerchantCategoriesInner } from './get-cards200-response-inner-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetCards200ResponseInnerReissue } from './get-cards200-response-inner-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { GetCards200ResponseInnerUser } from './get-cards200-response-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { GetCards200ResponseInnerUserAccountGroup } from './get-cards200-response-inner-user-account-group';

/**
 * 
 * @export
 * @interface GetCards200ResponseInner
 */
export interface GetCards200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCards200ResponseInner
     */
    'availableCurrencies': Array<GetCards200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetCards200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof GetCards200ResponseInner
     */
    'availableMerchantCategories': Array<GetCards200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetCards200ResponseInnerUser}
     * @memberof GetCards200ResponseInner
     */
    'user': GetCards200ResponseInnerUser;
    /**
     * 
     * @type {GetCards200ResponseInnerUserAccountGroup}
     * @memberof GetCards200ResponseInner
     */
    'userAccountGroup'?: GetCards200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCards200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInner
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCards200ResponseInner
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {GetCards200ResponseInnerReissue}
     * @memberof GetCards200ResponseInner
     */
    'reissue'?: GetCards200ResponseInnerReissue | null;
}

export const GetCards200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetCards200ResponseInnerAvailableCurrenciesEnum = typeof GetCards200ResponseInnerAvailableCurrenciesEnum[keyof typeof GetCards200ResponseInnerAvailableCurrenciesEnum];


